// extracted by mini-css-extract-plugin
export default {"cls1":"_9qp5IYWw09KoLrGE1hN","cls2":"ImLMvfPmMWwTRd4SdQUM _9qp5IYWw09KoLrGE1hN","embedCustomColors":"HkSYK6HBDt89AL0q4Nje"};